export enum TicketTypeActionTypeInternal {

   user_defined,
   simple,
   ticket,
   process,
   notification,
   appointment
}